import { useNavigate } from 'react-router-dom';
import { useUnreadCount } from '../../hooks/useNotifications';

interface NotificationBellProps {
  reunionId: string;
  className?: string;
}

export function NotificationBell({ reunionId, className = '' }: NotificationBellProps) {
  const navigate = useNavigate();
  const { data } = useUnreadCount(reunionId);
  const count = data?.count ?? 0;

  return (
    <button
      onClick={() => navigate('/inbox')}
      className={`relative p-2 text-gray-600 hover:text-gray-900 transition-colors ${className}`}
      aria-label={`Notifications${count > 0 ? `, ${count} unread` : ''}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
      {count > 0 && (
        <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
